// store.js
import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import rootReducer from "./reducers/rootReducer";

const persistConfig = {
  key: "root",
  storage,
  // Inbox counts and messages are read fresh on every load; persisting them
  // would show another session's badge before the first summary arrives.
  blacklist: ["inbox"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Enhancers and middleware
const enhancers = compose(
  applyMiddleware(thunk),
  window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f,
);

const store = createStore(persistedReducer, enhancers);
const persist = persistStore(store);

export { store, persist };
